import { Storybook } from "@tento-ui/ui/storybook";
import { DshTurnResult } from "./result";

/** The fixture's failing turn, verbatim from `thread/fixture.ts`. */
const FIXTURE_DETAIL = [
  "dispatch::tests::records_interleave_by_clock_not_by_seq",
  "  left:  [ctl#1, news#1, ctl#2]",
  "  right: [ctl#1, ctl#2, news#1]",
].join("\n");

export class DshTurnResultStoryBook extends Storybook.Default {
  title(): string {
    return "Turn · dsh · result";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Ok — nothing at all between these two replies",
        render: () => {
          const $wrap = column();
          $wrap.append(
            reply("Folded the six files into their owning commits."),
            DshTurnResult.makeWith({
              status: "ok",
              text: "end_turn · session afb69f67",
            }),
            reply("There is a result between these two replies."),
          );
          return $wrap;
        },
      },
      {
        title: "Error — a mark, a message, and the body one word away",
        render: () =>
          DshTurnResult.makeWith({
            status: "error",
            text: "1 test failed after the merge change",
            detail: FIXTURE_DETAIL,
          }),
      },
      {
        title: "Error, opened",
        render: () =>
          DshTurnResult.makeWith({
            status: "error",
            text: "1 test failed after the merge change",
            detail: FIXTURE_DETAIL,
            expanded: true,
          }),
      },
      {
        title: "A trailing code takes the third column",
        render: () =>
          DshTurnResult.makeWith({
            status: "error",
            text: "the build did not finish · exit 101",
            detail:
              "error[E0432]: unresolved import `tento_env::EnvKv`\n  --> tento-spool/src/main.rs:4:5",
          }),
      },
      {
        title: "Lines past the first sit under the title",
        render: () =>
          DshTurnResult.makeWith({
            status: "error",
            text:
              "deno check failed · exit 1\nThe symbol \"bindPrimaryCell\" has already been declared",
          }),
      },
      {
        title: "Suspended — the one ending a reader cannot infer",
        render: () => {
          const $wrap = column();
          $wrap.append(
            DshTurnResult.makeWith({
              status: "suspended",
              text: "Parked — approval apr-311 pending",
            }),
            DshTurnResult.makeWith({
              status: "suspended",
              text: "Stopped — the turn hit its step budget · 40/40",
              detail: [
                "steps: 40/40",
                "last: execute cargo test -p tento-spool",
                "resume: tsh session resume 9f2c41a8",
              ].join("\n"),
            }),
          );
          return $wrap;
        },
      },
    ];
  }
}

function reply(text: string): HTMLElement {
  const $reply = document.createElement("p");
  $reply.style.margin = "0";
  $reply.style.fontSize = "14px";
  $reply.style.lineHeight = "1.6";
  $reply.textContent = text;
  return $reply;
}

function column(): HTMLElement {
  const $wrap = document.createElement("div");
  $wrap.style.display = "flex";
  $wrap.style.flexDirection = "column";
  $wrap.style.gap = "6px";
  $wrap.style.width = "100%";
  return $wrap;
}
